import { h } from 'preact';

import Divider from '@mui/material/Divider';

export const RpmDivider = h(Divider, {
  orientation: 'vertical',
  flexItem: true,
  variant: 'outlined',
  sx: {
    color: '#5f6368',
    marginLeft: 'auto',
    display: { xs: 'none', md: 'inherit' },
  },
});
